import React from 'react'
import { useRecoilValue } from 'recoil'
import { useIntl } from 'react-intl'
import {
  Panel,
  Spinner,
  SPACING_4,
  SpacingVertical,
  TEXT_VARIANT_LIGHT,
  SPACING_8,
  Text,
  TEXT_VARIANT_BOLD,
  ProgressBarSmall,
  TruncateAndTooltip,
  ThumbContainer,
  Thumb,
  Flex,
  FlexItem
} from 'mailup-web-components'
import './BoxWinningMessage.scss'

import { abTestState } from 'Pages/AbTestWizard/recoil/state/abtest'

const BoxWinningMessage = () => {
  const intl = useIntl()
  const { step1, step4 } = useRecoilValue(abTestState)

  function getTitle() {
    if (step1.tipoTest === 'A') {
      if (step1.criterio === 1) {
        return intl.formatMessage({
          id: 'Load.AbTest.SendWinnerMessageAutoBestOpenDescr'
        })
      }
      if (step1.criterio === 2) {
        return intl.formatMessage({
          id: 'Load.AbTest.SendWinnerMessageAutoBestClickDescr'
        })
      }
    }
    if (step1.tipoTest === 'M') {
      return intl.formatMessage({
        id: 'Load.AbTest.SendWinnerMessageManualDescr'
      })
    }
  }
  return (
    <>
      <Panel collapsible={false}>
        <Flex>
          <FlexItem width='90px' justifySelf='flex-start'>
            <ThumbContainer>
              <Thumb>
                <span className='abtest_step4-winner_message_icon' />
              </Thumb>
            </ThumbContainer>
          </FlexItem>

          <FlexItem
            margin='0 0 0 24px'
            justifySelf='flex-end'
            width='calc(100% - 125px)'
          >
            <SpacingVertical variant={SPACING_4} />
            <Text variant={TEXT_VARIANT_BOLD}>
              <TruncateAndTooltip text={getTitle()} />
            </Text>
            <SpacingVertical variant={SPACING_8} />
            <Text variant={TEXT_VARIANT_LIGHT}>
              {intl.formatMessage({ id: 'Load.MailupCommon.Recipients' })}{' '}
              {step4.winningMessage.Queued ? (
                intl.formatNumber(step4.winningMessage.Queued)
              ) : (
                <Spinner />
              )}
            </Text>
            <SpacingVertical variant={SPACING_8} />
            <ProgressBarSmall
              perc={intl.formatNumber(100 - step1.percTest, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 0
              })}
            />
          </FlexItem>
        </Flex>
      </Panel>
    </>
  )
}

export default BoxWinningMessage
